import { ReactNode } from "react";
import { PermissionEnum } from "../../types";
import { useHasPermission } from "@/shared/hooks";

interface PermissionGuardProps {
	permission: PermissionEnum | PermissionEnum[];
	children: ReactNode;
	fallback?: ReactNode;
}

const PermissionGuard = ({ permission, children, fallback = null }: PermissionGuardProps) => {
	const hasPermission = useHasPermission(permission);

	if (!hasPermission) return <>{fallback}</>;

	return <>{children}</>;
};

export { PermissionGuard };
